import React, { useEffect, useState, useContext, useCallback } from 'react';
import { Button, withStyles } from '@material-ui/core';
import { useHistory, Link } from 'react-router-dom';
import { store } from '../../global-store/popupContext';
import DashboardLayout from '../../components/DashboardLayout';
import { prepschoolClasses } from '../../apis/prepschoolClasses';
import { closePageLoader, displayPageLoader, displayAlert } from '../../helpers/popupHelpers';
import LiveClassInfoTab from '../../components/upload-classes-tabs/LiveClassInfoTab';
import { RemoveRedEye } from '@material-ui/icons';

const UploadLiveCourse = (props) => {
  const history = useHistory();

  const { dispatch } = useContext(store);

  const [user] = useState(JSON.parse(localStorage.getItem('prepschool_auth')));
  const [course, setCourse] = useState(null);

  const tabs = [
    { name: 'home', title: 'Home', href: '/users/tutors/dashboard' },
    { name: 'profile', title: 'My Profile', href: '/tutor-profile/' + user.user_id },
    { name: 'bookings', title: 'View Bookings', href: '/tutor/bookings/accept' }
  ];

  const fetchCourse = useCallback(() => {
    displayPageLoader(dispatch);
    prepschoolClasses().get('/live-courses/' + props.match.params.id)
      .then((data) => {
        closePageLoader(dispatch);
        localStorage.setItem('prepschool_course', JSON.stringify(data.data.data));
        setCourse(data.data.data);
      })
      .catch((err) => {
        closePageLoader(dispatch);
        history.push('/upload-classes/live');
      });
  }, [dispatch, props.match.params.id, history]);
  
  useEffect(() => {
    if (!props.match.params.id) return localStorage.removeItem('prepschool_course');
    if (props.match.params.id) fetchCourse();
  }, [props.match.params.id, fetchCourse]);

  const publishCourse = () => {
    displayPageLoader(dispatch);
    prepschoolClasses().patch(`/live-courses/${props.match.params.id}`, { status: 'published' })
      .then((data) => {
        closePageLoader(dispatch);
        setCourse(data.data.data);
        displayAlert(dispatch, 'success', 'Life Course published!!!')
      })
      .catch((err) => {
        closePageLoader(dispatch);
        if (err.response) displayAlert(dispatch, 'error', err.response.data.error);
        else displayAlert(dispatch, 'error', 'Request could not be completed');
      });
  }

  return (
    <DashboardLayout tabs={tabs} tutorsOnly>
      <section className="upload-classes-page">
        <div className="ucpage-top-div" style={{marginBottom:30}}>
          <h1>Create live course</h1>
          <div>
            <ColorButton
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch({
                  type: 'DISPLAY_CONFIRM_ACTION_MODAL',
                  payload: { open: true, message: '', action: publishCourse }
                });
              }}
              disabled={!props.match.params.id}
            >
              publish
            </ColorButton>
          </div>
          <p>
            <Link color="inherit" to={'/preview-live-class/' + props.match.params.id}>
              <RemoveRedEye /> Preview class
            </Link>
          </p>
        </div>
        <div className="ucpage-bottom-div">
          <div className="ucpage-sidebar">
            <h3>Edit</h3>
            <hr />
            <ul>
              <li>Course Info</li>
            </ul>
          </div>
          {!props.match.params.id
            ? <LiveClassInfoTab />
            : null
          }
          {props.match.params.id && course
            ? <LiveClassInfoTab course={course} setCourse={setCourse} />
            : null
          }
        </div>
      </section>
    </DashboardLayout>
  );
};

export default UploadLiveCourse;

const ColorButton = withStyles((theme) => ({
  root: {
    '&:hover': {
      backgroundColor: '#0c946e',
    },
    backgroundColor: '#0FD9A0',
    height: 45,
    color: 'white',
    width: 160,
    fontSize: 14,
    letterSpacing: 1.4,
  },
}))(Button);
